import { render, staticRenderFns } from "./particularsInfo.vue?vue&type=template&id=3b7bd18d&scoped=true"
import script from "./particularsInfo.vue?vue&type=script&lang=js"
export * from "./particularsInfo.vue?vue&type=script&lang=js"
import style0 from "./particularsInfo.vue?vue&type=style&index=0&id=3b7bd18d&prod&lang=scss&scoped=true"
import style1 from "./particularsInfo.vue?vue&type=style&index=1&id=3b7bd18d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7bd18d",
  null
  
)

export default component.exports